import React from "react";
import MonitoringRouter from "../router/monitoring";

const MonitoringLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <MonitoringRouter />
    </div>
  );
};

export default MonitoringLayout;
